import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import PressKit from '../components/press-page/press-kit';
import pressMenuHide from '../lib/press-menu-hide';

class PressKitRoute extends Component {
  componentDidMount() {
    pressMenuHide();
  }

  render() {
    return (
      <div>
        <DocumentTitle title="Press Kit | NerdWallet" />
        <PressKit />
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressKitRoute.displayName = 'PressKitRoute';
PressKitRoute.analyticsName = 'press_kit_page';
PressKitRoute.segmentPageName = 'press_kit';

export default PressKitRoute;
